export default "__VITE_ASSET__Bz_cG2jc__"